import * as React from 'react'
import { useEffect, Suspense } from 'react'
import Lenis from 'lenis'

// Layout (lazy loaded)
const Navbar = React.lazy(() => import('./components/layout/Navbar').then(m => ({ default: m.Navbar })))
const Footer = React.lazy(() => import('./components/layout/Footer').then(m => ({ default: m.Footer })))

// Sections (lazy loaded)
const HeroSection = React.lazy(() => import('./components/sections/HeroSection').then(m => ({ default: m.HeroSection })))
const ProblemsSection = React.lazy(() => import('./components/sections/ProblemsSection').then(m => ({ default: m.ProblemsSection })))
const ServicesSection = React.lazy(() => import('./components/sections/ServicesSection').then(m => ({ default: m.ServicesSection })))
const ProcessSection = React.lazy(() => import('./components/sections/ProcessSection').then(m => ({ default: m.ProcessSection })))
const ResultsSection = React.lazy(() => import('./components/sections/ResultsSection').then(m => ({ default: m.ResultsSection })))
const AboutSection = React.lazy(() => import('./components/sections/AboutSection').then(m => ({ default: m.AboutSection })))
const FaqSection = React.lazy(() => import('./components/sections/FaqSection').then(m => ({ default: m.FaqSection })))
const ContactSection = React.lazy(() => import('./components/sections/ContactSection').then(m => ({ default: m.ContactSection })))

export default function App() {
  // Titre de l'accueil : réinitialise le <title> quand on revient d'une page
  // légale en navigation client (sinon l'onglet garde le titre de la page légale).
  useEffect(() => {
    document.title = 'Lorenz Campan - Expert IA & Automatisation'
  }, [])

  // Smooth scroll configuration
  useEffect(() => {
    const lenis = new Lenis({
      lerp: 0.1,
      smoothWheel: true,
    })

    function raf(time: number) {
      lenis.raf(time)
      requestAnimationFrame(raf)
    }

    requestAnimationFrame(raf)

    return () => {
      lenis.destroy()
    }
  }, [])

  return (
    <div className="min-h-screen selection:bg-accent/30 selection:text-white bg-surface text-white">
      {/* Layout principal */}
      <Suspense fallback={<div className="h-16 bg-surface" />}>
        <Navbar />
      </Suspense>

      <main className="relative z-10 flex flex-col w-full overflow-clip pb-[20vh] lg:pb-10">
        <Suspense fallback={<div className="h-screen bg-skeleton animate-pulse" />}>
          <HeroSection />
        </Suspense>
        
        <Suspense fallback={<div className="h-screen bg-skeleton animate-pulse" />}>
          <ProblemsSection />
        </Suspense>
        
        <Suspense fallback={<div className="h-screen bg-skeleton animate-pulse" />}>
          <ServicesSection />
        </Suspense>
        
        <Suspense fallback={<div className="h-screen bg-skeleton animate-pulse" />}>
          <ProcessSection />
        </Suspense>
        
        <Suspense fallback={<div className="h-screen bg-skeleton animate-pulse" />}>
          <ResultsSection />
        </Suspense>
        
        <Suspense fallback={<div className="h-screen bg-skeleton animate-pulse" />}>
          <AboutSection />
        </Suspense>
        
        <Suspense fallback={<div className="h-screen bg-skeleton animate-pulse" />}>
          <ContactSection />
        </Suspense>
        
        <Suspense fallback={<div className="h-screen bg-skeleton animate-pulse" />}>
          <FaqSection />
        </Suspense>
      </main>

      <Suspense fallback={<div className="h-32 bg-surface" />}>
        <Footer />
      </Suspense>
    </div>
  )
}

